import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { logout } = useAuth();
  const token = params.get("token") || "";

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!token) toast.error("Link non valido: token mancante");
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (!token) return;
    if (password.length < 6) { toast.error("La password deve avere almeno 6 caratteri"); return; }
    if (password !== confirm) { toast.error("Le due password non coincidono"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      logout();
      setDone(true);
      toast.success("Password aggiornata. Ora puoi accedere.");
      setTimeout(() => nav("/login", { replace: true }), 1500);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Impossibile reimpostare la password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex" data-testid="reset-password-page">
      <div className="hidden lg:block lg:w-1/2 relative" style={{
        backgroundImage: "url(https://images.unsplash.com/photo-1585945037805-5fd82c2e60b1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400)",
        backgroundSize: "cover", backgroundPosition: "center",
      }}>
        <div className="absolute inset-0 bg-[#FAF9F6]/30" />
        <div className="absolute bottom-12 left-12 right-12">
          <div className="text-[10px] tracking-luxury text-[#1A1A1A]/70 uppercase mb-2">Cosmely &middot; Recupero accesso</div>
          <h1 className="font-serif text-5xl text-[#1A1A1A] leading-tight">Scegli una nuova<br/>password sicura.</h1>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center px-8">
        <form onSubmit={submit} className="w-full max-w-sm animate-fade-in-up">
          <div className="font-serif text-3xl mb-1">Reimposta password</div>
          <div className="text-sm text-[#707070] mb-10">Inserisci la tua nuova password</div>

          {done ? (
            <div className="rounded border border-[#E5E5E0] bg-[#F5F2EC] p-5 text-sm text-[#1A1A1A]"
                 data-testid="reset-password-success">
              Password aggiornata con successo. Ti stiamo reindirizzando al login&hellip;
            </div>
          ) : (
            <>
              <label className="label-tiny">Nuova password</label>
              <input data-testid="reset-password-input" className="input-luxury mb-5" type="password"
                     minLength={6} value={password} onChange={(e)=>setPassword(e.target.value)} required
                     autoComplete="new-password" />

              <label className="label-tiny">Conferma password</label>
              <input data-testid="reset-password-confirm-input" className="input-luxury mb-8" type="password"
                     minLength={6} value={confirm} onChange={(e)=>setConfirm(e.target.value)} required
                     autoComplete="new-password" />

              <button data-testid="reset-password-submit" disabled={loading || !token}
                      className="btn-primary w-full">
                {loading ? "Salvataggio..." : "Salva nuova password"}
              </button>
            </>
          )}

          <div className="text-center mt-6">
            <Link to="/login" data-testid="reset-back-to-login"
                  className="text-xs text-[#707070] underline">Torna al login</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
